import vtkElevationReader from './ElevationReader';
import vtkITKImageReader from './ITKImageReader';
import vtkJSONNucleoReader from './JSONNucleoReader';
import vtkJSONReader from './JSONReader';
import vtkMTLReader from './MTLReader';
import vtkOBJReader from './OBJReader';
import vtkPDBReader from './PDBReader';
import vtkSkyboxReader from './SkyboxReader';

export default {
  vtkElevationReader,
  vtkITKImageReader,
  vtkJSONNucleoReader,
  vtkJSONReader,
  vtkMTLReader,
  vtkOBJReader,
  vtkPDBReader,
  vtkSkyboxReader,
};
